"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var waitDOMLoaded = function waitDOMLoaded(anim) {
  return new Promise(function (resolve) {
    anim.addEventListener('DOMLoaded', function () {
      resolve();
    }, {
      once: true
    });
  });
};

var _default = waitDOMLoaded;
exports["default"] = _default;